import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var defaults = {
  lines: 12,
  length: 7,
  width: 5,
  radius: 10,
  scale: 1.0,
  corners: 1,
  color: '#000',
  fadeColor: 'transparent',
  animation: 'spinner-line-fade-default',
  rotate: 0,
  direction: 1,
  speed: 1,
  zIndex: 2e9,
  className: 'spinner',
  top: '50%',
  left: '50%',
  shadow: '0 0 1px transparent',
  position: 'absolute'
};

var Spinner = function Spinner(options) {
  var _this = this;

  _classCallCheck(this, Spinner);

  _defineProperty(this, "el", void 0);

  _defineProperty(this, "opts", void 0);

  _defineProperty(this, "animateId", void 0);

  _defineProperty(this, "spin", function (target) {
    _this.stop();

    _this.el = document.createElement('div');
    _this.el.className = _this.opts.className;

    _this.el.setAttribute('role', 'progressbar');

    css(_this.el, {
      position: _this.opts.position,
      width: 0,
      zIndex: _this.opts.zIndex,
      left: _this.opts.left,
      top: _this.opts.top,
      transform: "scale(".concat(_this.opts.scale, ")") //"scale(" + this.opts.scale + ")"

    });

    if (target) {
      target.insertBefore(_this.el, target.firstChild || null);
    }

    drawLines(_this.el, _this.opts);
    return _this;
  });

  _defineProperty(this, "stop", function () {
    if (_this.el) {
      if (typeof requestAnimationFrame !== 'undefined') {
        cancelAnimationFrame(_this.animateId);
      } else {
        clearTimeout(_this.animateId);
      }

      if (_this.el.parentNode) {
        _this.el.parentNode.removeChild(_this.el);
      }

      _this.el = undefined;
    }

    return _this;
  });

  this.opts = Object.assign({}, defaults, options || {});
};
/**
 * Adds the spinner to the given target element. If this instance is already
 * spinning, it is automatically removed from its previous target by calling
 * stop() internally.
 */


export { Spinner };
/**
 * Sets multiple style properties at once.
 */

function css(el, props) {
  for (var prop in props) {
    el.style[prop] = props[prop];
  }

  return el;
}
/**
 * Returns the line color from the given string or array.
 */


function getColor(color, idx) {
  return typeof color == 'string' ? color : color[idx % color.length];
}
/**
 * Internal method that draws the individual lines.
 */


function drawLines(el, opts) {
  var borderRadius = "".concat(Math.round(opts.corners * opts.width * 500) / 1000, "px");
  var shadow = 'none';

  if (opts.shadow === true) {
    shadow = '0 2px 4px #000'; // default shadow
  } else if (typeof opts.shadow === 'string') {
    shadow = opts.shadow;
  }

  var shadows = parseBoxShadow(shadow);

  for (var i = 0; i < opts.lines; i++) {
    var degrees = ~~(360 / opts.lines * i + opts.rotate);
    var backgroundLine = css(document.createElement('div'), {
      position: 'absolute',
      top: "".concat(-opts.width / 2, "px"),
      width: "".concat(opts.length + opts.width, "px"),
      height: "".concat(opts.width, "px"),
      background: getColor(opts.fadeColor, i),
      borderRadius: borderRadius,
      transformOrigin: 'left',
      transform: "rotate(".concat(degrees, "deg) translateX(").concat(opts.radius, "px)") //"rotate(" + degrees + "deg) translateX(" + opts.radius + "px)"

    });
    var delay = i * opts.direction / opts.lines / opts.speed;
    delay -= 1 / opts.speed; // so initial animation state will include trail

    var line = css(document.createElement('div'), {
      width: '100%',
      height: '100%',
      background: getColor(opts.color, i),
      borderRadius: borderRadius,
      boxShadow: normalizeShadow(shadows, degrees),
      animation: "".concat(1 / opts.speed, "s linear ").concat(delay, "s infinite ").concat(opts.animation)
    });
    if (opts.lineColorClass) line.setAttribute('class', opts.lineColorClass);
    backgroundLine.appendChild(line);
    el.appendChild(backgroundLine);
  }
}

function parseBoxShadow(boxShadow) {
  var regex = /^\s*([a-zA-Z]+\s+)?(-?\d+(\.\d+)?)([a-zA-Z]*)\s+(-?\d+(\.\d+)?)([a-zA-Z]*)(.*)$/;
  var shadows = [];

  for (var _i = 0, _a = boxShadow.split(','); _i < _a.length; _i++) {
    var shadow = _a[_i];
    var matches = shadow.match(regex);

    if (matches === null) {
      continue; // invalid syntax
    }

    var x = +matches[2];
    var y = +matches[5];
    var xUnits = matches[4];
    var yUnits = matches[7];

    if (x === 0 && !xUnits) {
      xUnits = yUnits;
    }

    if (y === 0 && !yUnits) {
      yUnits = xUnits;
    }

    if (xUnits !== yUnits) {
      continue; // units must match to use as coordinates
    }

    shadows.push({
      prefix: matches[1] || '',
      x: x,
      y: y,
      xUnits: xUnits,
      yUnits: yUnits,
      end: matches[8]
    });
  }

  return shadows;
}
/**
 * Modify box-shadow x/y offsets to counteract rotation
 */


function normalizeShadow(shadows, degrees) {
  var normalized = [];

  for (var _i = 0, shadowsL = shadows; _i < shadowsL.length; _i++) {
    var shadow = shadowsL[_i];
    var xy = convertOffset(shadow.x, shadow.y, degrees);
    normalized.push("".concat(shadow.prefix).concat(xy[0]).concat(shadow.xUnits, " ").concat(xy[1]).concat(shadow.yUnits).concat(shadow.end));
  }

  return normalized.join(', ');
}

function convertOffset(x, y, degrees) {
  var radians = degrees * Math.PI / 180;
  var sin = Math.sin(radians);
  var cos = Math.cos(radians);
  return [Math.round((x * cos + y * sin) * 1000) / 1000, Math.round((-x * sin + y * cos) * 1000) / 1000];
}